import { Injectable } from "@angular/core";
import { SessionService } from "@edl-development/edl-common";
import { ItemPacketApi } from "src/app/api/item-packet/item-packet.api";
import { PagedModel } from "src/app/model/common/paged.model";
import { EdlItemPacketFormDTO } from "src/app/model/item-packet/edl-item-packet-form-dto.model";
import { PortalHelpersService } from "../portal-helpers/portal-helpers.service";
import { from, Observable } from "rxjs";
import { EdlItemPacketUserSummaryDTO } from "src/app/model/item-packet/edl-item-packet-user-summary-dto.model";

@Injectable()
export class ItemPacketService {

    constructor(
        private itemPacketApi: ItemPacketApi,
        private sessionService: SessionService,
        private portalHelpersService: PortalHelpersService
    ) { }

    get = (id:string) => this.itemPacketApi.get(id);

    getPackets = (paging: PagedModel) => this.itemPacketApi.getPackets(paging);
    
    getPacketsForUser = (userId: string): Observable<EdlItemPacketUserSummaryDTO[]> => this.runIfPortalSettingsOn(() => this.itemPacketApi.getPacketsForUser(userId), []);
    
    getPacketsForUserSupervisionItems = (userId: string): Observable<EdlItemPacketUserSummaryDTO[]> => this.runIfPortalSettingsOn(() => this.itemPacketApi.getPacketsForUserSupervisionItems(userId), []);
    
    getAllPackets = () => this.runIfPortalSettingsOn(() => this.itemPacketApi.getAllPackets(), []);

    getMyPermissions = () => this.runIfPortalSettingsOn(() => this.itemPacketApi.getMyPermissions(), []);

    create = (packet: EdlItemPacketFormDTO) => this.itemPacketApi.create(packet);

    save = (packet: EdlItemPacketFormDTO) => this.itemPacketApi.save(packet);

    publish = (packet: EdlItemPacketFormDTO) => this.itemPacketApi.publish(packet);

    unpublish = (packet: EdlItemPacketFormDTO) => this.itemPacketApi.unpublish(packet);

    duplicate = (id: string) => this.itemPacketApi.duplicate(id);

    archive = (id:string) => this.itemPacketApi.archive(id);

    unarchive = (id:string) => this.itemPacketApi.unarchive(id);

    delete = (id:string) => this.itemPacketApi.delete(id);

    restore = (id:string) => this.itemPacketApi.restore(id);

    /**
     * Calls the action if portal settings are on, otherwise returns the default value.
     * @param action 
     * @param defaultReturn 
     * @returns 
     */
    private runIfPortalSettingsOn = <T>(action: () => Observable<T>, defaultReturn: T): Observable<T> => {
        const portalSettings = this.sessionService.PortalSettings;
        const canViewItemPackets = this.portalHelpersService.canViewItemPackets(portalSettings);

        return canViewItemPackets ? action() : from(Promise.resolve(defaultReturn));
    }
}